'use client'

import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import VideoModal from '@/components/wise/VideoModal'

// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

const StudentsTestimonials = () => {
  const [open, setOpen] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')

  const testimonials = [
    {
      image: '/wise-lp/images/students/Akshita-Mishra.png',
      videoUrl: 'https://www.youtube.com/watch?v=E9zN74OXqAA',
      name: 'Akshita Mishra',
    },
    {
      image: '/wise-lp/images/students/Pawan-Kumar.png',
      videoUrl: 'https://www.youtube.com/watch?v=cW42PjK2Csc',
      name: 'Pawan Kumar',
    },
    {
      image: '/wise-lp/images/students/Vanshita-Dave.png',
      videoUrl: 'https://www.youtube.com/watch?v=QzLQdSzJ5Wc',
      name: 'Vanshita Dave',
    },
  ]

  const openVideo = (url) => {
    setVideoUrl(url)
    setOpen(true)
  }

  const closeVideo = () => {
    setOpen(false)
    setVideoUrl('')
  }

  return (
    <>
      <section className="section_block">
        <div className="container text-center">
          <h2 className="title mb-1">Hear From Our Students</h2>
          <div className="classroom d-flex justify-content-center align-items-center">
            <p className="mb-5 classroom paragraph">
              Powerful journeys of MSU students who have grown, thrived, and made their mark in the real world
            </p>
          </div>
        </div>

        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          className="students-testimonial-slider overflow-hidden"
          loop
          speed={600}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation
          pagination={{ clickable: true }}
          slidesPerView={3}
          slidesPerGroup={1}
          breakpoints={{
            0: { slidesPerView: 1, slidesPerGroup: 1 },
            768: { slidesPerView: 1, slidesPerGroup: 1 },
            992: { slidesPerView: 2, slidesPerGroup: 1 },
            1200: { slidesPerView: 3, slidesPerGroup: 1 },
          }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index} className="slide">
              <div
                className="custom-card d-flex justify-content-center align-items-center flex-column"
                style={{
                  borderRadius: '20px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                <img
                  src={testimonial.image}
                  className="img-fluid custom-card-img"
                  alt={testimonial.name}
                />
                <button
                  type="button"
                  className="play-button"
                  onClick={() => openVideo(testimonial.videoUrl)}
                >
                  <img
                    src="https://cdn.msu.edu.in/landing-page-images/play-button.svg"
                    alt="Play button"
                  />
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <VideoModal open={open} videoUrl={videoUrl} onClose={closeVideo} />
    </>
  )
}

export default StudentsTestimonials